module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/og-coj_c-67ab0f38b7f74d5d519e8ea272931497.png";